module.exports = __webpack_public_path__ + "static/media/firstpersone-review.9a1324b1.png";